export const host_local_web = "http://localhost:3000/";
export const host_local = "http://127.0.0.1:8000";
export const host_web_empty = "";
export const host_web_http_ii_identity = "https://identity.ic0.app/";
export const host_web_ic0_app = "https://ic0.app";
export const host_web_http_ii_boundary = "https://boundary.ic0.app/";
export const plug_host_connect =  "https://plugwallet.ooo/";
export const plug_timeout_connect =  120000;
export const transaction_icp_fee =  10000;
export const transaction_icp_coinage_minimal =  500000;
export const transaction_icp_min_value =  100000;
export const plug_whitelist_connect = [];
// export const plug_whitelist_connect = new Array<string>();
export const plug_web_host = "http://localhost:3000/";
export const plug_connect = "Plug connected";
export const stoic_connect = "Stoic connected";